// TOP LEVEL IMPORTS
import React from 'react';
import PropTypes from 'prop-types';

// ANTD
import Form from 'antd/lib/form';
import Button from 'antd/lib/button';
import Switch from 'antd/lib/switch';
import notification from 'antd/lib/notification';
import 'antd/lib/switch/style/css';
// APOLLO
import { graphql, compose } from 'react-apollo';
import currentUserQuery from 'ApolloClient/Queries/currentUser';
// import { SET_SMS_NOTIFICATIONS } from '/imports/ui/apollo/mutations';
import setSMSNotifications from 'ApolloClient/Mutations/setSMSNotifications';

const FormItem = Form.Item;

class Switches extends React.PureComponent {
  constructor(props) {
    super(props);

    const { notificationsSettings } = this.props.user;
    const initState = {
      invoicePaid:
        (notificationsSettings && notificationsSettings.invoicePaid && notificationsSettings.invoicePaid.sms) || false,
      contractSigned:
        (notificationsSettings && notificationsSettings.contractSigned && notificationsSettings.contractSigned.sms) ||
        false,
      newLead: (notificationsSettings && notificationsSettings.newLead && notificationsSettings.newLead.sms) || false,
    };

    this.state = {
      ...initState,
      disabled: false, // whether or not the form submit button is disabled
    };
  }

  disableBtn = () => {
    this.setState({ disabled: true });
  };

  enableBtn = () => {
    this.setState({ disabled: false });
  };

  handleChange = ({ field, checked }) => {
    this.setState({ [field]: checked });
  };

  handleSubmit = async evt => {
    evt.preventDefault();

    const { setSMSNotifications } = this.props;
    const { invoicePaid, contractSigned, newLead } = this.state;

    this.disableBtn();

    const variables = {
      settings: {
        invoicePaid,
        contractSigned,
        newLead,
      },
    };

    try {
      await setSMSNotifications({
        // eslint-disable-line
        variables,
        refetchQueries: [{ query: currentUserQuery }],
      });
      notification.success({ message: 'Settings saved!' });
    } catch (exc) {
      console.log(exc);
      notification.error({ message: exc });
    }

    this.enableBtn();
  };

  render() {
    const { user } = this.props;
    const { invoicePaid, contractSigned, newLead, disabled } = this.state;

    const twilioSet = user.twilio && user.twilio.phone && user.twilio.phone.length > 0;

    if (!twilioSet) {
      return null;
    }

    return (
      <Form onSubmit={this.handleSubmit} style={{ marginTop: 20 }}>
        <FormItem>
          <Switch
            checked={invoicePaid}
            checkedChildren="ON "
            unCheckedChildren="OFF"
            onChange={checked => {
              this.handleChange({
                field: 'invoicePaid',
                checked,
              });
            }}
          />
          &nbsp;&nbsp;&nbsp;Invoice Paid by Client
        </FormItem>
        <FormItem>
          <Switch
            checked={contractSigned}
            checkedChildren="ON"
            unCheckedChildren="OFF"
            onChange={checked => {
              this.handleChange({
                field: 'contractSigned',
                checked,
              });
            }}
          />
          &nbsp;&nbsp;&nbsp;Contract Signed by Client
        </FormItem>
        <FormItem>
          <Switch
            checked={newLead}
            checkedChildren="ON "
            unCheckedChildren="OFF"
            onChange={checked => {
              this.handleChange({
                field: 'newLead',
                checked,
              });
            }}
          />
          &nbsp;&nbsp;&nbsp;New Lead Form Submitted
        </FormItem>
        <FormItem>
          <Button htmlType="submit" type="primary" disabled={disabled}>
            Save
          </Button>
        </FormItem>
      </Form>
    );
  }
}

const NotificationsType = {
  email: PropTypes.bool,
  sms: PropTypes.bool,
  push: PropTypes.bool,
};

Switches.propTypes = {
  user: PropTypes.shape({
    notificationsSettings: PropTypes.shape({
      invoicePaid: PropTypes.shape(NotificationsType),
      contractSigned: PropTypes.shape(NotificationsType),
      newLead: PropTypes.shape(NotificationsType),
    }),
  }).isRequired,
  setSMSNotifications: PropTypes.func.isRequired,
};

export default graphql(setSMSNotifications, { name: 'setSMSNotifications' })(Switches);



// WEBPACK FOOTER //
// ./src/routes/app-studio/AlertsArea/Switches/index.js